import Breadcrumbs from "../../../../components/shared/Breadcrumbs/Breadcrumbs";
import { ButtonsWrapper, PageContainer } from "../../../../styled";
import { Button } from "../../../../components/shared/Button/Button";
import { IconDeviceFloppy, IconHistory } from "@tabler/icons-react";
import { type SubmitHandler, useForm } from "react-hook-form";
import { IGenericLoginForm } from "../../../../components/pages/Settings/GenericLogins/GenericLogins.types";
import React from "react";
import { useGetApi, usePostApi } from "../../../../hooks";
import { getYachtId } from "../../../../utils";
import { useNavigate, useParams } from "react-router-dom";
import { genericDataMapper } from "./GeneralLoginsEdit.utils";
import { LayoutContainer, Section } from "../../../../styled/UserForm.styled";

import GenericLoginDetails from "../../../../components/pages/Settings/GenericLogins/GenericLoginsEdit/GenericLoginDetails";
import CheckboxGroup from "../../../../components/shared/_FormInputs/CheckboxGroup/CheckboxGroup";
import GenericLoginsSectionWrapper from "../../../../components/pages/Settings/GenericLogins/GenericLoginsEdit/GenericLoginsSectionWrapper";
import { Text } from "@mantine/core";
import { Notification } from "../../../../utils/Notification";
import Loader from "../../../../components/shared/Loader/Loader";
interface Props {
  newLogin?: boolean;
}
const GenericLoginsEdit = ({ newLogin }: Props) => {
  const navigate = useNavigate();
  const { genid } = useParams();
  const { post, isLoading: isPostLoading } = usePostApi();
  const { data, isLoading } = useGetApi({
    request: "get-generic-login",
    body: {
      params: {
        yachtid: getYachtId(),
        ...(newLogin ? {} : { genid }),
      },
    },
    mapper: genericDataMapper,
  });
  const {
    control,
    register,
    handleSubmit,
    reset,
    getValues,
    trigger,
    formState,
  } = useForm<IGenericLoginForm>({
    values: data?.filledData,
  });

  const submit: SubmitHandler<IGenericLoginForm> = async data => {
    if (!newLogin && !data.pass) {
      // @ts-ignore
      delete data.pass;
    }

    await post({
      request: "save-generic-login",
      body: {
        params: {
          ...data,
          logout: Number(data.logout),
          ...(newLogin ? {} : { genid }),
          yachtid: getYachtId(),
        },
      },
    });
    Notification("Success", "Generic login saved successfully", "green");
    navigate("/settings/gen");
    reset();
  };
  const onSubmit = async () => {
    const result = await trigger();
    if (result && getValues().users.length > 0) {
      await handleSubmit(submit)();
    } else {
      Notification(
        "Validation Error",
        !result
          ? "Fill in the required fields"
          : "You must select at least one user",
        "red",
      );
    }
  };
  if (isLoading)
    return (
      <div style={{ margin: "200px auto" }}>
        <Loader />
      </div>
    );
  return (
    <PageContainer>
      <form>
        <Breadcrumbs border={false}>
          <ButtonsWrapper>
            {!newLogin && (
              <Button
                leftIcon={<IconHistory size={"1.4rem"} />}
                variant="outline"
                onClick={() => navigate("./history")}>
                History
              </Button>
            )}
            <Button
              leftIcon={<IconDeviceFloppy size={"1.4rem"} />}
              onClick={onSubmit}
              loading={isPostLoading}>
              Save
            </Button>
          </ButtonsWrapper>
        </Breadcrumbs>

        <LayoutContainer style={{ flexWrap: "wrap" }}>
          <GenericLoginsSectionWrapper title="Details">
            <GenericLoginDetails
              register={register}
              errors={formState.errors}
              control={control}
              isNew={newLogin}
            />
          </GenericLoginsSectionWrapper>
          <GenericLoginsSectionWrapper title="Assigned Logbooks">
            <CheckboxGroup
              name="logbooks"
              control={control}
              data={data?.selects?.logbooks ?? []}
              searchable
            />
          </GenericLoginsSectionWrapper>
          <GenericLoginsSectionWrapper title="Permissions">
            <CheckboxGroup
              name="perms"
              control={control}
              data={data?.selects?.perms ?? []}
              grouped
              searchable
              renderLabel={perm => (
                <>
                  <Text style={{ flex: 1, paddingRight: 2 }}>{perm.label}</Text>
                  <Text style={{ flex: 1.5, opacity: 0.7 }} size="xs">
                    {perm.description}
                  </Text>
                </>
              )}
            />
          </GenericLoginsSectionWrapper>
          <GenericLoginsSectionWrapper title="Users">
            <CheckboxGroup
              name="users"
              control={control}
              data={data?.selects?.users ?? []}
              searchable
            />
          </GenericLoginsSectionWrapper>
        </LayoutContainer>
      </form>
    </PageContainer>
  );
};
export default GenericLoginsEdit;
